var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    transform: "matrix(1 0 0 -1 1 23)",
    fill: "#F7D5D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 15V12.5L16.6295 13.8705L15.5 15H18Z",
    fill: "#E75C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9L10.0667 13.6154L12.4 10.3846L16.6295 13.8705M16.6295 13.8705L18 15M16.6295 13.8705L18 12.5V15M16.6295 13.8705L15.5 15H18",
    stroke: "#E75C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsDown);
export default __webpack_public_path__ + "static/media/stats-down.dfa47b72f5c4230aa4f5d618d6768dee.svg";
export { ForwardRef as ReactComponent };